<template>
  <div class="comp-product">
    <div class="icon">
      <img @error="imgError" :src="data.Illustration" :alt="data.Headline" />
    </div>
    <div class="name">{{ data.Headline }}</div>
    <div class="desc">{{ data.Summary }}</div>
  </div>
</template>

<script>
export default {
  name: "product-card",
  props: {
    data: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.comp-product {
  width: 376px;
  height: 292px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(69, 80, 238, 0.08);
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 24px;
  margin-left: 24px;
  .icon {
    width: 376px;
    height: 176px;
    overflow: hidden;
    border-radius: 8px 8px 0 0;
    transition: all 0.3 ease;
  }
  .name {
    font-size: 20px;
    font-weight: 500;
    line-height: 22px;
    padding: 20px 24px 10px 24px;
  }
  .desc {
    color: #999;
    line-height: 22px;
    padding: 0 24px;
    @include ellipsisc(2);
  }
  &:nth-child(3n-2) {
    margin-left: 0;
  }
  &:hover {
    box-shadow: 0px 4px 12px 0px rgba(69, 80, 238, 0.16);
  }
}
</style>
